var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 26 26",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M6 2h8M6 3h8M4 4h2m8 0h8M4 5h2m8 0h8M4 6h2m16 0h2M4 7h2m16 0h2M4 8h2m16 0h2M4 9h2m16 0h2M2 10h2m18 0h2M2 11h2m18 0h2M2 12h2m16 0h2M2 13h2m16 0h2M2 14h2m16 0h2M2 15h2m16 0h2M0 16h2m4 0h6m8 0h2M0 17h2m4 0h6m8 0h2M0 18h2m4 0h2m4 0h8M0 19h2m4 0h2m4 0h8M0 20h2m4 0h2m-8 1h2m4 0h2m-6 1h4m-4 1h4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "gray",
    d: "M6 4h2M6 5h2M6 6h2M6 7h2M6 8h2M6 9h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3e4256",
    d: "M8 4h2M8 5h2M8 6h2M8 7h2M8 8h2M8 9h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M10 4h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d0e8e8",
    d: "M12 4h2m-2 1h2m-2 1h2m6 0h2M12 7h2m6 0h2M12 8h2m6 0h2M12 9h2m6 0h2m-12 1h2m8 0h2m-12 1h2m8 0h2m-12 1h2m6 0h2m-10 1h2m6 0h2m-10 1h2m6 0h2m-10 1h2m6 0h2m-2 1h2m-2 1h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b5c9c9",
    d: "M14 6h2m2 0h2m-6 1h2m2 0h2m-6 1h2m2 0h2m-6 1h2m2 0h2m-8 1h4m2 0h2m-8 1h4m2 0h2m-8 1h2m2 0h2m-6 1h2m2 0h2m-6 1h2m2 0h2m-6 1h2m2 0h2m-6 1h2m2 0h2m-6 1h2m2 0h2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9dadad",
    d: "M16 6h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-4 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.17a3760f8ce652694fd0bc610297cbe3.svg";
export { ForwardRef as ReactComponent };